<template>
	<v-card
		class="item-card background"
		:class="getCardStatusClass(item)">
		<v-card-title class="py-0 pr-0 pl-2">
			{{ item.name }}
			<v-spacer></v-spacer>
			<v-btn flat icon small class="ma-0 ml-2" @click="remove">
				<v-icon>close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text class="pa-0">
			<div v-if="item.type === 'image'">
				<v-img :src="generateURL(item.file)" height="100px"></v-img>
			</div>
			<div v-else style="text-align: center">
				<v-icon :size="98">file_present</v-icon>
				<span v-if="item.block_reasons.length">
					{{ item.file.size | humanizeBytes1000 }}
				</span>
			</div>
		</v-card-text>
		<v-card-text
			v-if="item.block_reasons.length"
			class="px-1 py-0">
			<v-spacer></v-spacer>
			<div
				v-for="(br, brIndex) in item.block_reasons"
				:key="'br_' + brIndex"
				class="">
				{{ br }}
			</div>
			<v-spacer></v-spacer>
		</v-card-text>
		<v-card-actions
			v-if="item.error"
			class="py-0">
			<span v-safe-html="item.error"></span>
		</v-card-actions>
		<v-card-actions class="pa-0" v-if="!item.block_reasons.length">
			<v-progress-linear
				height="20"
				color="primary lighten-1"
				:value="item.progress">
				<span class="pl-1 bottom-infos">
					{{ item.file.size | humanizeBytes1000 }}
				</span>
				<span class="float-right pr-1 bottom-infos">
					{{ Math.floor(item.progress) }}%
				</span>
			</v-progress-linear>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: [ 'item' ],
	methods: {
		remove (evt) {
			evt.stopPropagation()
			this.$emit('delete')
		},
		generateURL (file) {
			let fileSrc = URL.createObjectURL(file)
			setTimeout(() => URL.revokeObjectURL(fileSrc), 1000)
			return fileSrc
		},
		getCardStatusClass (item) {
			if (item.block_reasons.length) return 'invalid-card'
			if (item.error) return 'invalid-card'
			return 'valid-card'
		}
	}
}
</script>

<style lang="stylus" scoped>
.item-card
	&:before
	&:after
		content: none

.bottom-infos
	color: white
	text-shadow: 0 0 2px black

.valid-card
	outline: 1px solid var(--v-primary-base)
	color: var(--v-primary-base)
	.v-icon
		color: var(--v-primary-base)

.invalid-card
	outline: 2px dashed var(--v-red-lighten1)
	color: var(--v-red-lighten1)
	.v-icon
		color: var(--v-red-lighten1)

</style>



// WEBPACK FOOTER //
// src/pages/about/ticket_attachment_item.vue